module.exports = __webpack_public_path__ + "img/GA.557983a8.jpg";